/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Ahmed Saeed",
  title: "Hi all, I'm Ahmed Saeed",
  subTitle: emoji(
    "A Senior Software Engineer 🚀 (experienced front-end developer) with over 3+ years of working experience in the web and mobile industry with the latest javaScript libraries and frameworks. "
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/asaeed14",
  linkedin: "https://www.linkedin.com/in/aseed14/",
  gmail: "ahmedsaeedtc@gmail.com",
  gitlab: "https://gitlab.com/AhmedSaeedFS",
  facebook: "https://www.facebook.com/profile.php?id=100051028387398",
  stackoverflow: "https://stackoverflow.com/users/10502248/asaeed",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "A FRONT-END DEVELOPER WHO LOVE'S TO WRITE SCALABLE AND MAINTAINABLE CODE TO PROVIDE BEST FRONT-END SOLUTIONS",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your cross platform (android and ios) mobile applications."
    ),
    emoji("⚡ Front-end architecture with best practcies and latest techs."),
    emoji(
      "⚡ Integration of third party servies (API's)  with latest libraries such as redux-toolkit and saga middleware."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "reactnative",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "redux-toolkit",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "animations",
      fontAwesomeClassname: "fab fa-radiation"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName:
        "FAST (NUCES) National University of Computer and Emerging Sciences",
      logo: require("./assets/images/nu_logo.png"),
      subHeader: "Bachelor in Science in Computer Science",
      duration: "Aug 2014 - June 2018"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Project Architecture",
      progressPercentage: "90%"
    },
    {
      Stack: "TypeScript/Javascript", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "ReactNative/Redux/API integeration/firebase and much more..",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "FetchSky (Peekaboo Guru)",
      companylogo: require("./assets/images/peekabooLogo.png"),
      date: "June 2018 – Present",
      desc:
        "Peekaboo Guru is a location based platform which acts as your complete lifestyle guide and shows all the deals and discounts offered in the market.  I have 3+ years of front-end working experience at peekaboo guru , I am working in the domain of mobile and web application.  Very good understanding of writing scalable and maintainable front-end architecture for products. Solved three cross-platform mobile apps challenges which mainly focus on performance increase, code repetition, start-up time and good state management strategy. Experience in creating a good designs in a perspective of user experience (UI/UX).  Experience in integration of api’s, firebase technology and other third party libraries"
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "ahmedsaeed", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME OF THE PROJECT's THAT I LEAD AND CONTRIBUTE",
  projects: [
    {
      image: require("./assets/images/peekabooLogo.png"),
      projectName: "Peekaboo Guru",
      projectDesc:
        "Peekaboo Guru is a location based platform which acts as your complete lifestyle guide and shows all the deals and discounts offered in the market.  I have 3+ years of front-end working experience at peekaboo guru , I am working in the domain of mobile and web application.  Very good understanding of writing scalable and maintainable front-end architecture for products. Solved three cross-platform mobile apps challenges which mainly focus on performance increase, code repetition, start-up time and good state management strategy. Experience in creating a good designs in a perspective of user experience (UI/UX). In this project we used latest techs such us react-native, saga, redux-toolkit , sub-modules, firebase etc..",
      footerLink: [
        {
          name: "IOS App",
          url: "https://apps.apple.com/pk/app/peekaboo-guru/id1114129707"
        },
        {
          name: "Android App",
          url:
            "https://play.google.com/store/apps/details?id=com.fetchsky.peekaboo"
        }
      ]
    },
    {
      image: require("./assets/images/bogo.png"),
      projectName: "BOGO (Buy One Get One)",
      projectDesc:
        "A buy one get one offers mobile application who offers you lifestyle experiences especially at restaurants, salons & spas, retail, entertainment, travel,online shopping and more. In this project we used latest techs such us react-native, saga, redux-toolkit , typescripts, sub-modules, firebase etc..",
      footerLink: [
        {
          name: "IOS App",
          url: "https://apps.apple.com/pk/app/bogo-pakistan/id1116123646"
        },
        {
          name: "Android App",
          url: "https://play.google.com/store/apps/details?id=com.bogo.android"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/efu.png"),
      projectName: "EFU PlantIT",
      projectDesc:
        "EFU Life PlanIT provides comprehensive solutions for all your life insurance needs. The app includes various features for all our existing clients and for those who wish to know about us and insurance. In this project we used latest techs such us react-native, saga, redux-toolkit , sub-modules, firebase etc..",
      footerLink: [
        {
          name: "IOS App",
          url: "https://apps.apple.com/us/app/efu-life-planit/id1007214538"
        },
        {
          name: "Android App",
          url:
            "https://play.google.com/store/apps/details?id=com.efulife.customer"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Open Source 🖥️ "),
  subtitle: "A little effort that I have shared with react-native community!",

  achievementsCards: [
    {
      title: "React Native Animated Skeleton",
      subtitle:
        "React Naive Animated Skeleton for both android and ios, Runs on native thread with smooth performance",
      image: require("./assets/images/reactnative.png"),
      footerLink: [
        {
          name: "NPM",
          url: "https://www.npmjs.com/package/react-native-animated-skeleton"
        },
        {
          name: "GitHub",
          url: "https://github.com/asaeed14/react-native-animated-skeleton"
        }
      ]
    },
    {
      title: "React Native Toast",
      subtitle:
        "React Native JS level toast for both android and IOS which can be called from any component of your app",
      image: require("./assets/images/reactnative.png"),
      footerLink: [
        {
          name: "NPM",
          url: "https://www.npmjs.com/package/@asaeed14/react-native-toast"
        },
        {
          name: "GitHub",
          url: "https://github.com/asaeed14/react-native-toast"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@ahmedsaeed/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/ahmedsaeed-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---ahmed-saeed-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3472422241",
  emailAddress: "ahmedsaeedtc@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
